






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Button from '@/components/utils/Button.vue';

@Component({
  components: {
    Button,
  },
})
export default class Thumbnail extends Vue {
  @Prop({ type: String, required: true, default: '' }) readonly school!: string;

  @Prop({ type: String, required: true, default: '' }) readonly branch!: string;

  @Prop({ type: String, required: true, default: '' }) readonly status!: string;

  @Prop({ type: Object, required: true, default: '' }) readonly item!: any;

  get compIcones(): Array<any> {
    switch (this.status) {
      case 'validated':
        return [
          { icon: require('@/assets/icons/badgeReferencedLine.svg'), class: '' },
          { icon: require('@/assets/icons/badgeValidatedLine.svg'), class: 'smaller' },
        ];
      case 'waiting':
        return [{ icon: require('@/assets/icons/badgeWaitingLine.svg'), class: 'smaller2' }];
      case 'ongoing':
        return [{ icon: require('@/assets/icons/badgeOnGoingLine.svg'), class: 'smaller' }];
      case 'denied':
        return [{ icon: require('@/assets/icons/badgeRefusedLine.svg'), class: 'smaller' }];
      default:
        return [];
    }
  }

  get compString(): string {
    switch (this.status) {
      case 'validated':
        return 'Validée';
      case 'waiting':
        return 'En attente';
      case 'ongoing':
        return 'En cours';
      case 'denied':
        return 'Refusée';
      default:
        return '';
    }
  }

  get compName(): string {
    return `${this.item.prenom_usager} ${this.item.nom_usager}`;
  }

  get compBranch(): string {
    if (this.item.branch) {
      return `Antenne: ${this.item.branch.city} (${this.item.branch.departmentNumber})`;
    }
    return 'Antenne: Non renseignée';
  }

  detailsClicked(): void {
    const details = {
      id: this.item.id,
      queueName: this.item.adresse_ecole,
      branchName: this.branch,
      queueManager: this.compName,
      phone: this.item.telephone_usager,
      email: this.item.mail_usager,
      schoolAddress: this.item.adresse_ecole,
      schoolZip: this.item.zip_code_ecole,
      schoolCity: this.item.nom_ville_ecole,
      status: this.item.status,
      requestDate: this.item.created_at,
    };
    this.onDetailsClicked();
  }

  @Emit('detailsClicked')
  onDetailsClicked(): void {}
}
